import {
    FormControl,
    FormControlLabel,
    Switch,
    SwitchProps,
    Typography,
} from '@mui/material';
import React from 'react';
import { Control, Controller } from 'react-hook-form';

interface FormSwitchProps extends SwitchProps {
    name: string;
    control: Control<any>;
    label?: string;
    small?: boolean;
    labelSx?: any;
}

const FormSwitch = ({
    name,
    control,
    label,
    small = false,
    labelSx,
    ...props
}: FormSwitchProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { value, onChange, ref },
                fieldState: { error },
            }) => (
                <FormControl component='fieldset'>
                    <FormControlLabel
                        sx={{ marginRight: 0 }}
                        control={
                            <Switch
                                {...props}
                                size={small ? 'small' : 'medium'}
                                inputRef={ref}
                                checked={value ? Boolean(value) : false}
                                onChange={onChange}
                            />
                        }
                        label={
                            <Typography
                                sx={{
                                    color: 'text.primary',
                                    fontSize: '14px',
                                    ...labelSx,
                                }}
                            >
                                {label}
                            </Typography>
                        }
                    />
                </FormControl>
            )}
        />
    );
};

export default FormSwitch;
